export const UPLOAD_BULK_TRANSACTION_START =
  'UPLOAD_BULK_TRANSACTION_START';
export const UPLOAD_BULK_TRANSACTION_SUCCESS =
  'UPLOAD_BULK_TRANSACTION_SUCCESS';
export const UPLOAD_BULK_TRANSACTION_ERROR =
  'UPLOAD_BULK_TRANSACTION_ERROR';
